import {
  useBreadcrumbRoutes,
  Wrapper,
  Select,
  Form,
  Tabs,
  CustomFilter,
  DatePicker,
  Input,
  Themes,
  useTheme,
  MultiSelect,
} from '@maxtropy/components';
import React, { useState, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { EnergyUseType, EnergyUseDisplay } from './utils';
import EnergySourcesPlan from './EnergySourcesPlan';
import DelayApplication from './DelayApplication';
import {
  apiV2EnergyConsumptionPlanGetStaffDeptPost,
  V2EnergyConsumptionPlanGetStaffDeptPostResponse,
  V2EnergyConsumptionPlanGetAreaListPostResponse,
  apiV2EnergyConsumptionPlanGetStaffOrgMappingPost,
  apiV2EnergyConsumptionPlanGetAreaListPost,
} from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';
import { isEmpty } from 'lodash-es';
export interface SearchProps {
  ownerOrgId?: string;
  zoneIdList?: number[];
  userName?: string;
  time?: [Dayjs, Dayjs];
}
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

const EnergyUsageApplication: React.FC = () => {
  const [urlSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [form] = Form.useForm();
  const theme = useTheme();

  const tabs = urlSearchParams.get('tabs') || EnergyUseType.ENERGY_PLAN;
  const [tabsKey, setTabsKey] = useState<string>(tabs);
  const [searchParams, setSearchParams] = useState<SearchProps>({});
  const [areaOp, setAreaOp] = useState<V2EnergyConsumptionPlanGetAreaListPostResponse['list']>([]);
  const [sectionOp, setSectionOp] = useState<V2EnergyConsumptionPlanGetStaffDeptPostResponse['list']>([]);
  const ownerOrgId = Form.useWatch('ownerOrgId', form);
  const hasApplicationForDelay = useHasPermission(PermissionsType.B_APPLICATIONFORDELAY); // 报警
  const hasEnergyUsePlan = useHasPermission(PermissionsType.B_NEWENERGYUSEPLAN);

  const items = [
    hasEnergyUsePlan && {
      key: EnergyUseType.ENERGY_PLAN,
      label: EnergyUseDisplay[EnergyUseType.ENERGY_PLAN],
    },
    hasApplicationForDelay && {
      key: EnergyUseType.DELAY_APPLICATION,
      label: EnergyUseDisplay[EnergyUseType.DELAY_APPLICATION],
    },
  ].filter(Boolean);

  useEffect(() => {
    apiV2EnergyConsumptionPlanGetStaffDeptPost({}).then(res => {
      setSectionOp(res.list);
    });
  }, []);

  useEffect(() => {
    if (tabsKey === EnergyUseType.DELAY_APPLICATION) {
      setAreaOp([]);
      if (isEmpty(ownerOrgId)) return;
      apiV2EnergyConsumptionPlanGetAreaListPost({ id: ownerOrgId }).then(res => {
        setAreaOp(res.list);
      });
    } else {
      apiV2EnergyConsumptionPlanGetStaffOrgMappingPost({}).then(res => {
        setAreaOp(res.areaList ?? []);
      });
    }
  }, [ownerOrgId, tabsKey]);

  const onFinish = (val: SearchProps) => {
    setSearchParams({ ...val });
  };

  const onReset = () => {
    const params = {
      ownerOrgId: undefined,
      zoneIdList: undefined,
      userName: undefined,
      time: undefined,
    };
    form.setFieldValue('zoneIdList', undefined);
    setSearchParams(params);
    tabsKey === EnergyUseType.DELAY_APPLICATION && setAreaOp([]);
  };

  const filters = (
    <div>
      <Tabs
        defaultActiveKey={tabsKey}
        items={items}
        selectedLinePlacement="top"
        onChange={v => {
          onReset();
          setTabsKey(v);
          urlSearchParams.delete('tabs');
          urlSearchParams.append('tabs', v);
          navigate(`?${urlSearchParams.toString()}`);
        }}
      />
      <div style={{ padding: '0 20px' }}>
        <CustomFilter form={form} onFinish={val => onFinish(val as any)} onReset={onReset}>
          {tabsKey === EnergyUseType.DELAY_APPLICATION && (
            <Form.Item name="ownerOrgId" label="部门">
              <Select
                style={{ width: '100%' }}
                placeholder="请选择"
                showSearch
                optionFilterProp="label"
                onChange={() => {
                  form.setFieldValue('zoneIdList', undefined);
                }}
                options={sectionOp?.map(s => ({ label: s.ownerOrgName, value: s.ownerOrgId }))}
              />
            </Form.Item>
          )}

          <Form.Item name="zoneIdList" label="区域名称">
            <MultiSelect
              placeholder="请选择"
              showSearch
              optionFilterProp="label"
              maxTagCount={1}
              options={areaOp?.map(a => ({ label: a.zoneName, value: a.id }))}
            />
          </Form.Item>
          <Form.Item name="userName" label="申请人">
            <Input placeholder="请选择" />
          </Form.Item>
          <Form.Item name="time" label="申请时间">
            <RangePicker
              style={{ width: '100%' }}
              // disabledDate={date => {
              //   return dayjs().isBefore(date);
              // }}
              format={dateFormat}
            />
          </Form.Item>
        </CustomFilter>
      </div>
    </div>
  );

  return (
    <Wrapper
      routes={breadcrumbRoutes?.routes}
      className={styles.page_wrapper}
      filters={hasEnergyUsePlan || hasApplicationForDelay ? filters : null}
      filtersStyle={{ padding: 0 }}
    >
      {!hasEnergyUsePlan && !hasApplicationForDelay && (
        <div className={styles.contentNot}>
          <div className={`${styles.logoNot} ${theme === Themes.DARK ? styles.darkImg : styles.lightImg}`} />
          <div>暂无数据权限</div>
        </div>
      )}
      {hasEnergyUsePlan && tabsKey === EnergyUseType.ENERGY_PLAN && <EnergySourcesPlan searchParams={searchParams} />}
      {hasApplicationForDelay && tabsKey === EnergyUseType.DELAY_APPLICATION && (
        <DelayApplication searchParams={searchParams} />
      )}
    </Wrapper>
  );
};

export default EnergyUsageApplication;
